import React, { PropTypes } from "react";
import { NavItem } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const ChangePasswordButton = (props) => {
  return (
    <NavItem eventKey="1" onClick={props.onClickHandler}>
      <span className="icon icon-lock" />
      <FormattedMessage id="passwordForm.changePassword" />
    </NavItem>
  );
};

ChangePasswordButton.propTypes = {
  onClickHandler: PropTypes.func.isRequired,
};

export default ChangePasswordButton;



// WEBPACK FOOTER //
// ./src/components/common/ChangePassword/ChangePasswordButton.js